// Mirrors reporting-hub's PreflightPage Tab 2 "Validation": read-only
// Preflight Results, Data Quality Control (Loan Number Check + Investment
// Amount Check), editable Pending Loans, editable Manual Loan Exclusions,
// editable Cost Realization (global), Cashflow Reconciliation + drilldown,
// and an Export Issues download - each section a standalone component
// fetching its own data (see validation/*.js).

import React, { useEffect, useState, useCallback } from 'react';
import axiosWithAuth from '../../../helpers/AxiosHelper';
import { Accordion, AccordionTab } from 'primereact/accordion';
import PreflightPanel from '../PreflightPanel';
import DataQualityControlPanel from '../validation/DataQualityControlPanel';
import PendingLoansPanel from '../validation/PendingLoansPanel';
import ManualExclusionsPanel from '../validation/ManualExclusionsPanel';
import CostRealizationPanel from '../validation/CostRealizationPanel';
import CashflowReconciliationPanel from '../validation/CashflowReconciliationPanel';
import ExportIssuesButton from '../validation/ExportIssuesButton';
import { Button } from 'primereact/button';
import { readErrorDetail } from '../jobs';
import errorMessage from '../../../helpers/errorMessage';

const ValidationTab = ({ reportingId, setLoading, onViewLoanTape }) => {
  const [preflightReport, setPreflightReport] = useState(null);
  const [error, setError] = useState(null);

  const fetchPreflight = useCallback(async () => {
    if (!reportingId) return;
    setLoading(true);
    try {
      const res = await axiosWithAuth.get(`/compartment-report/reportings/${reportingId}/preflight`);
      setPreflightReport(res.data);
      setError(null);
    } catch (err) {
      console.error('[ValidationTab] preflight fetch error:', errorMessage(err));
      setError(readErrorDetail(err, 'Failed to load preflight report.'));
    } finally {
      setLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reportingId]);

  useEffect(() => {
    fetchPreflight();
  }, [fetchPreflight]);

  return (
    <div>
      <div className="ex-section-header">
        <h3 className="ex-section-title">Validation</h3>
        <div className="ex-toolbar-group">
          <Button
            label="View LoanTape"
            icon="pi pi-table"
            className="p-button-secondary p-button-outlined p-button-sm"
            onClick={() => onViewLoanTape && onViewLoanTape()}
          />
          <ExportIssuesButton reportingId={reportingId} setLoading={setLoading} />
        </div>
      </div>
      {error && <div className="ex-inline-error mb-3">{error}</div>}

      <Accordion multiple activeIndex={[0]}>
        <AccordionTab header="Preflight Results">
          <PreflightPanel report={preflightReport} onJumpToRow={onViewLoanTape} />
        </AccordionTab>
        <AccordionTab header="Data Quality Control">
          <DataQualityControlPanel reportingId={reportingId} setLoading={setLoading} onJumpToRow={onViewLoanTape} />
        </AccordionTab>
        <AccordionTab header="Cashflow Reconciliation">
          <CashflowReconciliationPanel reportingId={reportingId} setLoading={setLoading} />
        </AccordionTab>
        <AccordionTab header="Pending Loans">
          <PendingLoansPanel reportingId={reportingId} setLoading={setLoading} />
        </AccordionTab>
        <AccordionTab header="Manual Loan Exclusions">
          <ManualExclusionsPanel reportingId={reportingId} setLoading={setLoading} />
        </AccordionTab>
        <AccordionTab header="Cost Realization">
          <CostRealizationPanel reportingId={reportingId} setLoading={setLoading} />
        </AccordionTab>
      </Accordion>
    </div>
  );
};

export default ValidationTab;
